import { View } from 'react-native'
export const Card = ({ children, style, setCardWidth = null }) => {
    const cardPadding = 16
    return (
        <View
            style={[
                {
                    backgroundColor: 'white',
                    borderRadius: 16,
                    padding: cardPadding,
                    shadowColor: '#000',
                    shadowOpacity: 0.06,
                    shadowRadius: 8,
                    elevation: 2,
                },
                style,
            ]}
            onLayout={(e) => {
                if (setCardWidth) {
                    const boxWidth = e.nativeEvent.layout.width
                    setCardWidth(boxWidth - cardPadding * 2)
                }
            }}
        >
            {children}
        </View>
    )
}
